import http from 'plugins/axios'

export default {
  //获取交易对列表
  getSymbolList() {
    return http.get({
      url: '/la/admin/tenant/symbol/getSymbolList',
      data: { type: 'CONTRACT' },
    })
  },

  //获取币种列表
  getCoinList() {
    return http.get({
      url: '/channel/common/coinList',
    })
  },
  getHistory(data) {
    return http.get({
      url: '/api/thanos-admin/v1/admin/activity/list',
      data,
    })
  },
  exportExcel(params) {
    return http.get({
      url: '/la/admin/channel/position/listLog/excel',
      params,
      responseType: 'blob',
    })
  },
  getHistoryInfo(params) {
    return http.get({
      url: '/la/admin/channel/position/listLogTotalInfo',
      params,
    })
  },
  delPositionId(positionId) {
    return http.post({
      url: `/la/admin/channel/position/deleteHistory?positionId=${positionId}`,
    })
  },

  //添加租户活动任务列表
  addLottery(data) {
    return http.post({
      url: '/api/thanos-admin/v1/admin/activity/add',
      data,
    })
  },
  //所属类别列表
  getTaskType() {
    return http.get({
      url: '/api/thanos-admin/v1/admin/activity/global/taskType',
    })
  },
  // 获取逻辑操作符

  getLogicOp() {
    return http.get({
      url: '/api/thanos-admin/v1/admin/activity/logic/op',
    })
  },
  // 获取数学操作符
  getMathOp() {
    return http.get({
      url: '/api/thanos-admin/v1/admin/activity/math/op',
    })
  },
  // 奖励金列表
  getLotteryList(params) {
    return http.get({
      url: '/api/thanos-admin/v1/admin/activity/lottery/list',
      params,
    })
  },
  // 用户类型获取
  getUserTypeList(params) {
    return http.get({
      url: '/api/thanos-admin/v1/admin/activity/userType/list',
      params,
    })
  },
  // 上架-下架
  getActive(data) {
    return http.put({
      url: '/api/thanos-admin/v1/admin/activity/active',
      data,
    })
  },
}
